import {history} from 'new-components/router/history';
import {select, put, takeEvery} from 'redux-saga/effects';
import {
	CHECK_PHONE_CODE_SUCCESS,
	DELETE_CARD_SUCCESS,
	SEND_ORDER_SUCCESS,
	SET_LOCALE_SUCCESS, SUBMIT_APPLE_PAY_SUCCESS, SUBMIT_GOOGLE_PAY_SUCCESS,
} from 'new-constants/api.constants';
import {checkPaymentStatus, getCustomer} from 'new-actions/api.actions.ts';
import {PROFILE_STRIPE_SUCCES, STRIPE_SUCCESS, VIPPS_SUCCESS} from 'new-constants/payment.constants';
import {setInfoMessage} from "../managers/client-log.manager";
import {cancelInitial, openInitial, openSelectLocation} from "../actions/popup.actions";
import {MARK_POPUP_AS_SHOWN_SUCCESS, REPEAT_ORDER_SUCCESS, RESTAURANT_LIST_SUCCESS} from "../constants/api.constants";
import {
	getAdyenRedirectResultSelector,
	getAvailableOrderingTypesSelector,
	getCurrentRestaurantListSelector
} from "../selectors";
import {OrderingTypes, PaymentStatuses} from "../constants/common.constants";
import {getStartupParams} from "../helpers/startup-params.helper";
import {getCurrentRestaurantIdSelector} from "../selectors";
import {setOrderTypeInitial} from "../actions/ordering-mode.actions";
import {DONE_SERVER} from "../constants/popup.constants";
import {delay} from "@redux-saga/core/effects";
import {getRestaurantListByZip} from "../actions/api.actions";
import {getCartRoute, getOrderRoute} from "../helpers/routes.helper";
import {ADYEN_SUCCESS} from "../constants/payment.constants";
import {getCashpoints} from 'new-actions/api.actions.ts';

function* refreshCustomer() {
	const state = yield select();
	
	yield put(getCustomer(getCurrentRestaurantIdSelector(state)));
}
function* fetchCashpoints() {
	yield put(getCashpoints());
}
function* openOrder(action) {
	if (!action.payload.data.stripeClientSecret && !action.payload.data.redirectUrl && !action.payload.data.adyenClientKey) {
		history.replace(
			getOrderRoute(action.payload.data.order.orderId, true)
		);
		setInfoMessage(`Open order ${action.payload.data.order.orderId}`);
	}
}

function* openOrderAfterPayment(action) {
	history.replace(
		getOrderRoute(action.orderId, true)
	);
	setInfoMessage(`Open order after payment ${action.orderId}`);
}

function* openOrderAfterAdyenPayment(action) {
	if (!action.payload.redirectToOrder || action.payload.action.resultCode !== PaymentStatuses.authorised) {
		return;
	}
	history.replace(
		getOrderRoute(action.payload.orderId, true)
	);
	setInfoMessage(`Open order after payment ${action.payload.orderId}`);
}

function* speedUpCardRegistration(action) {
	yield put(checkPaymentStatus(action.orderId));
}

function* showInitialPopup(action) {
	const state = yield select();
	const orderingTypes = getAvailableOrderingTypesSelector(state);
	if (!action.payload?.isFirstCall) {
		return
	}
	
	if (!!getAdyenRedirectResultSelector(state)) {
		return;
	}
	
	if (orderingTypes.length > 1 || orderingTypes.includes(OrderingTypes.delivery) || !getStartupParams().skipProfile) {
		yield put(openInitial());
	} else if (orderingTypes.length === 1 && getStartupParams().skipProfile) {
		yield put(setOrderTypeInitial(orderingTypes[0], getCurrentRestaurantListSelector(state)));
	}
}

function* openCartOnOrderRepeat(action) {
	yield delay(1000);//Wait for orderlines to be saved to store
	if (action.payload.isRewriteCurrentPage) {
		history.replace(getCartRoute());
	} else {
		history.push(getCartRoute());
	}
	
}

function* refreshZipRestaurantsIfNeeded(action) {
	if (action.payload.orderingType === OrderingTypes.delivery) {
		yield put(getRestaurantListByZip(action.payload.data.zip, true, true));
	}
}

export const apiSaga = function* apiSaga() {
	yield takeEvery([CHECK_PHONE_CODE_SUCCESS, DELETE_CARD_SUCCESS, MARK_POPUP_AS_SHOWN_SUCCESS], refreshCustomer);
	yield takeEvery(CHECK_PHONE_CODE_SUCCESS, fetchCashpoints);
	yield takeEvery(SEND_ORDER_SUCCESS, openOrder);
	yield takeEvery(SET_LOCALE_SUCCESS, refreshCustomer);
	yield takeEvery([ADYEN_SUCCESS, SUBMIT_GOOGLE_PAY_SUCCESS, SUBMIT_APPLE_PAY_SUCCESS], openOrderAfterAdyenPayment);
	
	yield takeEvery([STRIPE_SUCCESS, VIPPS_SUCCESS], openOrderAfterPayment);
	yield takeEvery([PROFILE_STRIPE_SUCCES], speedUpCardRegistration);
	yield takeEvery([RESTAURANT_LIST_SUCCESS], showInitialPopup);
	yield takeEvery([REPEAT_ORDER_SUCCESS], openCartOnOrderRepeat);
	yield takeEvery([REPEAT_ORDER_SUCCESS], refreshZipRestaurantsIfNeeded)
};
